module.exports = __webpack_public_path__ + "img/product1.c1102886.png";